/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface CustomQuestionnaireMultiSelectAnswer
 */
export interface CustomQuestionnaireMultiSelectAnswer {
  /**
   *
   * @type {number}
   * @memberof CustomQuestionnaireMultiSelectAnswer
   */
  id?: number;
  /**
   *
   * @type {Array<number>}
   * @memberof CustomQuestionnaireMultiSelectAnswer
   */
  value: Array<number>;
}

/**
 * Check if a given object implements the CustomQuestionnaireMultiSelectAnswer interface.
 */
export function instanceOfCustomQuestionnaireMultiSelectAnswer(
  value: object,
): value is CustomQuestionnaireMultiSelectAnswer {
  if (!('value' in value) || value['value'] === undefined) return false;
  return true;
}

export function CustomQuestionnaireMultiSelectAnswerFromJSON(json: any): CustomQuestionnaireMultiSelectAnswer {
  return CustomQuestionnaireMultiSelectAnswerFromJSONTyped(json, false);
}

export function CustomQuestionnaireMultiSelectAnswerFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CustomQuestionnaireMultiSelectAnswer {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'] == null ? undefined : json['id'],
    value: json['value'],
  };
}

export function CustomQuestionnaireMultiSelectAnswerToJSON(value?: CustomQuestionnaireMultiSelectAnswer | null): any {
  if (value == null) {
    return value;
  }
  return {
    id: value['id'],
    value: value['value'],
  };
}
